import React from 'react'
import LoginForm from './form'
import { useLocation, useNavigate } from 'react-router-dom'
import { AppDispatch, useAppDispatch } from '../../redux/store'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { getAuth } from '../../redux/reducers/userReducer'

/**Login is a view where the user log in into the app*/

interface AuthValues {
  email: string
  password: string
}
const Login = ({}: AuthValues) => {
  const dispatch: AppDispatch = useAppDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const principalView = '/dashboard'
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const emailParam = searchParams.get('email')

  const handleSubmit = async (values: AuthValues) => {
    try {
      const result = await dispatch(
        getAuth({ email: values.email, password: values.password })
      )
      const { payload } = result

      if (payload && payload.success) {
        const cookieValue = payload.data?.access_token
        document.cookie = `token=${cookieValue}; path=/`

        navigate(principalView)
      } else {
        toast(t('ERROR'))
      }
    } catch (error: any) {
      console.error('Error:', error)
    }
  }
  return (
    <>
      <div className='container-home width-100 d-flex'>
        <LoginForm
          onSubmit={handleSubmit}
          email={''}
          password={''}
        />
      </div>
    </>
  )
}

export default Login
